module.exports = __webpack_public_path__ + "static/media/es.776efab4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/countriesFlags/es.svg
// module id = 1444
// module chunks = 0